<template>
    <togglable-edit v-if="customer" class="text-sm">
        <template #static>
            <div class="flex justify-between w-full">
                <span class="text-muted">Leveringssted</span>
                <div class="w-full text-right">
                    {{ deliveryLocation.addressLine }}, {{ deliveryLocation.postalCode }} {{ deliveryLocation.postalLocation }}, {{ deliveryLocation.countryCode }}
                </div>
            </div>
        </template>
        <template #edit="{stopEdit}">
            <span class="text-muted">Leveringssted</span>
            <div class="flex gap-2 w-full mb-3 pt-4">
                <general-input
                    v-model="deliveryLocation.addressLine"
                    data-cy="address-input"
                    label="Adresse"
                    class="flex-1/2"
                    icon="i-ph-map-pin-fill"
                />
                <country-select
                    v-model="deliveryLocation.countryCode"
                    class="flex-1/2"
                    :is-valid="(countryCode: Maybe<string>) => countryCode?.length === 2 ? undefined : 'Mangler landskode'"
                />
            </div>
            <div class="flex gap-2 w-full mb-3">
                <general-input
                    v-model="deliveryLocation.postalCode"
                    class="flex-1/2"
                    label="Postnummer"
                    data-cy="postal-code-input"
                    :is-valid="(postalCode: Maybe<string>) => !!postalCode ? undefined : 'Mangler postnummer'"
                />
                <general-input
                    v-model="deliveryLocation.postalLocation"
                    class="flex-1/2"
                    label="Sted"
                    data-cy="postal-location-input"
                    :is-valid="(postalLocation: Maybe<string>) => !!postalLocation ? undefined : 'Mangler poststed'"
                />
            </div>
            <UButton color="primary" @click="stopEdit">Lagre</UButton>
        </template>
    </togglable-edit>
</template>

<script setup lang="ts">

import {Maybe} from '@/types/Maybe'
import GeneralInput from '@/components/GeneralInput.vue'
import CountrySelect from '@/subaccount/CountrySelect.vue'
import {useInvoiceCreator} from '@/invoice/invoice.service'

const {customer, deliveryLocation} = useInvoiceCreator()
</script>

<style scoped>

</style>